module.exports = __webpack_public_path__ + "img/icon-menu-program.c55aec9f.svg";